import * as React from 'react'

import { Container } from '../../_shared/Container'
import { LogoCard } from '../components/LogoCard'
import { SectionHead } from '../../_shared/SectionHead'
import { LOGOS } from '../content'
import styles from './Logos.module.css'

export function Logos(): React.ReactElement {
  return (
    <section className={styles.section} id="logos">
      <Container>
        <SectionHead
          title="Télécharger le logo Ulule"
          lede="Trois formats officiels du logo Ulule. Pour chaque format, basculez entre fond clair et fond sombre, puis téléchargez en PNG ou SVG."
        />
        <div className={styles.grid}>
          {LOGOS.map((logo) => (
            <LogoCard key={logo.id} logo={logo} />
          ))}
        </div>
      </Container>
    </section>
  )
}
